import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
const Gallery = () => {
  // Sample images with unique ids and different src/alt values
  const images = [
{ id: 1, src: "/images/fleets/1.jpeg", alt: "" },
{ id: 1, src: "/images/fleets/2.jpeg", alt: "" },
{ id: 1, src: "/images/fleets/3.jpeg", alt: "" },
{ id: 1, src: "/images/fleets/5.jpeg", alt: "" },
{ id: 1, src: "/images/fleets/7.jpeg", alt: "" },
{ id: 1, src: "/images/fleets/6.jpeg", alt: "" },
  { id: 2, src: "/images/fleets/2.jpg", alt: "Maruti Ertiga" },
  { id: 3, src: "/images/fleets/3.jpg", alt: "Scorpio" },
  { id: 4, src: "/images/fleets/4.jpg", alt: "Toyota Corolla Altis" },
  { id: 5, src: "/images/fleets/5.jpg", alt: "Tavera" },
  { id: 6, src: "/images/fleets/6.jpg", alt: "Toyota Etios" },
  { id: 7, src: "/images/fleets/7.jpg", alt: "Honda Amaze" },
  { id: 8, src: "/images/fleets/8.jpg", alt: "Innova Crysta" },
  { id: 9, src: "/images/fleets/9.jpg", alt: "Toyota Innova" },
{ id: 1, src: "/images/fleets/4.jpeg", alt: "" },


  { id: 10, src: "/images/fleets/10.jpg", alt: "Mini Bus Traveller" },
  { id: 11, src: "/images/fleets/11.jpg", alt: "Tempo Traveller" },
   
   
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Open modal and set the clicked image
  const openModal = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Show next image in the modal
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Show previous image in the modal
  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  

  
  return (

<>
 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title">Gallery</h2>
        </div>
      </div>
    </section>




    
    <div className="gallery-container ">
      <div className="gallery-grid ">
        {images.map((image, index) => (
          <img
            key={image.id}
            src={image.src}
            alt={image.alt}
            className="gallery-image-item borderr"
            onClick={() => openModal(index)} // Open the modal on click
          />
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay">
          <button className="modal-close-button" onClick={closeModal}>
            &times;
          </button>
          <div className="modal-content-container">
            <button className="modal-prev-button" onClick={prevImage}>
              &#10094;
            </button>
            <div className="modal-image-container  ">
              <img
                src={images[currentImageIndex].src}
                alt={images[currentImageIndex].alt}
                className="modal-image borderr"
              />
            </div>
            <button className="modal-next-button" onClick={nextImage}>
              &#10095;
            </button>
          </div>
        </div>
      )}
    </div>

</>
  );
};

export default Gallery;